import * as React from "react";
import { Col, Row, Glyphicon } from "react-bootstrap";

export default class MensajeConAccion extends React.Component<MensajeConAccionProps, any>{

    constructor(props: any) {
        super(props);

        this.ocultarAlerta = this.ocultarAlerta.bind(this);

        this.state = {
            visible: true
        };
    }

    ocultarAlerta() {
        this.setState({ visible: false });
    }

    render() {
        if (this.state.visible) {
            const { type, mensaje } = this.props;
            return (
                <div className={"alert alert-dismissible alert-" + type}>
                    <Row>
                        <Col sm={5}>
                            {mensaje}
                        </Col>
                        <Col smOffset={6} sm={1}>
                            <Glyphicon glyph={"remove"} onClick={this.ocultarAlerta} />
                        </Col>
                    </Row>
                </div>
            );
        }
        return false;
    }
}

interface MensajeConAccionProps {
    type: string,
    mensaje: string
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/MensajeConAccion.tsx